import {
  getFocusPerson,
  getPersonDisplayData,
  getPersonSpouses,
  getPersonParents,
  getPersonChildren,
  getPersonLifespan,
} from '@fs/zion-gedcomx'

const formatTreeResult = (result) => {
  const {
    content: { gedcomx, portrait, artifacts },
    score,
  } = result

  const person = getFocusPerson(gedcomx)
  const spouse = getPersonSpouses(gedcomx, person)?.map?.(({ person: p }) => p)
  const parent = getPersonParents(gedcomx, person)?.map?.(({ person: p }) => p)
  const children = getPersonChildren(gedcomx, person)?.map?.(({ person: p }) => p)
  const personDetails = getPersonDisplayData(person)
  const lifespan = getPersonLifespan(person)
  const genders = { F: 'female', M: 'male' }
  const gender = genders[personDetails?.sex] || 'unknown'

  return {
    ...personDetails,
    artifacts,
    children,
    gender,
    gedcomx,
    identifier: person?.id,
    lifespan,
    parent,
    portrait,
    score,
    spouse,
  }
}

export { formatTreeResult }
